module.exports = "data:image/webp;base64,UklGRnwBAABXRUJQVlA4IHABAAAQBwCdASoZABkAPpFAm0olo6IhqAgAsBIJZwDInAgdgR0+ru/Tf0ZfPASMnBjhJxUNqofdUGYc9rYhfGEntkhRMAD+50tGMRYI+4NmLCrAGMfmiblVdeBIQm3HrVl8/iXVtL2gRqMTQI7Wi1WHxaN7s7MvWEwJdCLVSdqBwQ5ufAre/wS8XFBn9FIajdazSUGhqT9CBn7NYyjCE3Ze9zd7r5kO2+9IG9T/EgeE4EdDfPyrTQALlyHrijQKfXr19/Mi3s/cyG+cKJglJDGLCLVh+5dOrEaN/fozjetuNtmVkSaezXfvfKrqJTGmsdppfVfxC3/dhcetmPH779hnkkL6mn84ZT0j5xSKSCGH5m9WzLORf/x1nDf1kPFaEyg6wOG2zPR/uYc2yaanU3bi4/th7E57WvNGPMrCHOulv9nntO2eOsJQUiLy/eKWExqhvVvAog55xCiI7Evzc69rXDi7YnhwzmTCPzCljL9ihozAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/Ocean_Veil_ws.webp
// module id = Zqoq
// module chunks = 14